import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function LegalNotice() {
  return (
    <div className="min-h-screen bg-black">
      <div className="max-w-4xl mx-auto px-4 py-16">
        <Link 
          to="/"
          className="inline-flex items-center gap-2 text-gray-400 hover:text-white mb-8 transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          Retour à l'accueil
        </Link>

        <h1 className="text-3xl font-bold text-white mb-8">Mentions Légales</h1>

        <div className="prose prose-invert max-w-none">
          <h2 className="text-xl font-semibold text-white mt-8 mb-4">1. Informations Légales</h2>
          <p className="text-gray-300 mb-6">
            Botmaker Agency est une SAS au capital de 10 000€<br />
            Siège social : 123 Avenue de la République, 75011 Paris<br />
            RCS Paris B 123 456 789<br />
            N° TVA : FR 12 345 678 901<br />
            Directeur de la publication : John Doe
          </p>

          <h2 className="text-xl font-semibold text-white mt-8 mb-4">2. Hébergement</h2>
          <p className="text-gray-300 mb-6">
            Le site botmaker-agency.com est hébergé par :<br />
            Supabase, Inc.<br />
            3505 El Camino Real, Palo Alto, CA 94306<br />
            États-Unis
          </p>

          <h2 className="text-xl font-semibold text-white mt-8 mb-4">3. Propriété Intellectuelle</h2>
          <p className="text-gray-300 mb-6">
            L'ensemble du site, y compris sa structure et son contenu (textes, images, vidéos, etc.), est protégé par le droit d'auteur et autres droits de propriété intellectuelle. Toute reproduction, représentation, modification ou adaptation totale ou partielle du site ou de son contenu, par quelque procédé que ce soit et sur quelque support que ce soit, est interdite sans l'autorisation expresse et préalable de Botmaker Agency.
          </p>

          <h2 className="text-xl font-semibold text-white mt-8 mb-4">4. Protection des Données</h2>
          <p className="text-gray-300 mb-6">
            Conformément à la loi "Informatique et Libertés" du 6 janvier 1978 modifiée et au Règlement Général sur la Protection des Données (RGPD), vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition aux données personnelles vous concernant. Pour exercer ces droits, contactez-nous à l'adresse : privacy@botmaker-agency.com
          </p>

          <h2 className="text-xl font-semibold text-white mt-8 mb-4">5. Cookies</h2>
          <p className="text-gray-300 mb-6">
            Le site utilise des cookies pour améliorer l'expérience utilisateur. En naviguant sur le site, vous acceptez l'utilisation de cookies conformément à notre politique de confidentialité.
          </p>

          <h2 className="text-xl font-semibold text-white mt-8 mb-4">6. Liens Hypertextes</h2>
          <p className="text-gray-300 mb-6">
            Le site peut contenir des liens vers d'autres sites. Botmaker Agency n'est pas responsable du contenu de ces sites et ne peut être tenu responsable des dommages résultant de leur utilisation.
          </p>

          <h2 className="text-xl font-semibold text-white mt-8 mb-4">7. Droit Applicable</h2>
          <p className="text-gray-300 mb-6">
            Les présentes mentions légales sont régies par le droit français. En cas de litige, les tribunaux français seront seuls compétents.
          </p>

          <h2 className="text-xl font-semibold text-white mt-8 mb-4">8. Contact</h2>
          <p className="text-gray-300 mb-6">
            Pour toute question concernant ces mentions légales, vous pouvez nous contacter :<br />
            Par email : contact@botmaker-agency.com<br />
            Par téléphone : +33 (0)1 23 45 67 89<br />
            Par courrier : Botmaker Agency, 123 Avenue de la République, 75011 Paris
          </p>
        </div>
      </div>
    </div>
  );
}